import { render, staticRenderFns } from "./detailDiff.vue?vue&type=template&id=5eb2c502&scoped=true"
import script from "./detailDiff.vue?vue&type=script&lang=js"
export * from "./detailDiff.vue?vue&type=script&lang=js"
import style0 from "./detailDiff.vue?vue&type=style&index=0&id=5eb2c502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb2c502",
  null
  
)

export default component.exports